<template>
  <div class="ca-pesquisa-grid pt-size-12">
    <div class="ca-pesquisa-grid__hero pt-size-8 lg:pt-size-10 pb-size-7">
      <div class="ca-bullet-container">
        <div class="ca-pesquisa-grid__header mb-size-6">
          <h1 class="ca-pesquisa-grid__title heading-jumbo">
            Resultados da Pesquisa
          </h1>
          <p class="ca-pesquisa-grid__count paragraph-small">
            {{ totalCount }} resultados para '<strong>{{ searchQuery }}</strong
            >'
          </p>
        </div>

        <CaPesquisaBar
          v-model="searchQuery"
          class="ca-pesquisa-grid__bar"
          @submit="submitSearch"
          @clear="clearSearch"
        />
      </div>
    </div>

    <div
      class="ca-pesquisa-grid__main rounded-size-8 lg:pt-size-8 pb-size-5 lg:pb-size-8"
    >
      <div
        class="ca-bullet-container ca-pesquisa-grid__main-content pt-size-8"
        :class="{ 'ca-pesquisa-grid__main-content--no-sidebar': !hasSidebar }"
      >
        <CaPesquisaFiltros
          v-if="!isEmpty"
          v-model="activeSegment"
          :tabs="tabs"
          :loading="loading"
          class="ca-pesquisa-grid__filtros"
        />

        <CaPesquisaVazio
          v-if="isEmpty"
          :query="searchQuery"
          :suggestion="currentSuggestion"
          :temas-relacionados="currentTemasRelacionados"
          class="ca-pesquisa-grid__lista"
        />
        <CaPesquisaLista
          v-else
          :results="paginatedResults"
          :loading="loading"
          class="ca-pesquisa-grid__lista"
        />

        <CaPesquisaMaisPesquisados
          v-if="hasSidebar"
          :title="maisPesquisados.title || 'Mais pesquisados'"
          :items="maisPesquisados.items"
          :loading="loading"
          class="ca-pesquisa-grid__sidebar"
        />

        <div v-if="totalPages > 1" class="ca-pesquisa-grid__paginacao">
          <CaPesquisaPaginacao
            :current-page="currentPage"
            :total-pages="totalPages"
            :max-visible="paginacaoMaxVisible"
            :loading="loading"
            @change="goToPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const mockTabs = [
  { label: "Todos", count: 1091, segment: "todos" },
  { label: "Particulares", count: 42, segment: "particulares" },
  { label: "Empresas", count: 32, segment: "empresas" },
  { label: "Institucional", count: 1015, segment: "institucional" },
  { label: "Sustentabilidade", count: 1, segment: "sustentabilidade" },
  { label: "Associados", count: 1, segment: "associados" },
];

const mockMaisPesquisados = [
  { title: "Ver cartões de crédito", url: "#" },
  { title: "Atualizar dados pessoais", url: "#" },
  { title: "Abrir conta online", url: "#" },
  { title: "Pedir crédito pessoal online", url: "#" },
  { title: "Abrir conta empresa", url: "#" },
  { title: "Atualizar dados empresas", url: "#" },
];

const mockSuggestion = {
  label: "crédito",
  url: "/pesquisa?phrase=cr%C3%A9dito",
};

const mockTemasRelacionados = [
  { title: "Simulador de Crédito", url: "#" },
  { title: "Crédito Pessoal", url: "#" },
  { title: "Crédito Habitação", url: "#" },
];

const isDev = import.meta.env.DEV;

const mockResults = [
  {
    title:
      "Prevenir e Regularização de situações de incumprimento de contrato de crédito",
    subtitle: "Dificuldades Financeiras",
    category: "AJUDA",
    categoryIcon: "ajuda",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Investir",
    subtitle: "Para Mim",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Simulador Crédito Pessoal",
    subtitle: "O melhor caminho para os seus sonhos.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Abra a sua conta no crédito agrícola. Nós tratamos de tudo.",
    subtitle: "Dia-a-dia",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Crédito Agrícola - Open Banking API",
    subtitle: "Serviços",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Crédito Habitação - CA Casa Energia Eficiente",
    subtitle: "A solução mais sustentável.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Simulador de Crédito Habitação",
    subtitle: "Calcule a sua prestação mensal.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Relatório de Sustentabilidade 2023",
    subtitle: "Compromisso com o futuro.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "sustentabilidade",
  },
  {
    title: "Linha de Apoio ao Investimento Empresarial",
    subtitle: "Soluções de financiamento para empresas.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Crédito ao Setor Agrícola",
    subtitle: "Financiamento adaptado às necessidades do agricultor.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Estatutos e Regulamentos",
    subtitle: "Documentação institucional do Crédito Agrícola.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "institucional",
  },
  {
    title: "Associados do Crédito Agrícola",
    subtitle: "Informação para associados.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "associados",
  },
];
</script>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import CaPesquisaBar from "./CaPesquisaBar.vue";
import CaPesquisaFiltros from "./CaPesquisaFiltros.vue";
import CaPesquisaLista from "./CaPesquisaLista.vue";
import CaPesquisaVazio from "./CaPesquisaVazio.vue";
import CaPesquisaMaisPesquisados from "./CaPesquisaMaisPesquisados.vue";
import CaPesquisaPaginacao from "./CaPesquisaPaginacao.vue";

const PAGE_SIZE = 10;

const props = defineProps({
  phrase: { type: String, default: "" },
  segment: { type: String, default: "todos" },

  tabs: { type: Array, default: () => (isDev ? mockTabs : []) },
  results: { type: Array, default: () => (isDev ? mockResults : []) },
  // Sugestão de spell check do Solr: { label, url } — null quando há resultados
  suggestion: { type: Object, default: () => (isDev ? mockSuggestion : null) },
  // Top resultados do termo sugerido — [] quando há resultados
  temasRelacionados: {
    type: Array,
    default: () => (isDev ? mockTemasRelacionados : []),
  },
  maisPesquisados: {
    type: Object,
    default: () => {
      if (typeof window !== "undefined" && window.__maisPesquisados) {
        return window.__maisPesquisados;
      }
      if (isDev)
        return { title: "Mais pesquisados", items: mockMaisPesquisados };
      return { title: "", items: [] };
    },
  },
});

const activeSegment = ref(props.segment);
const searchQuery = ref(props.phrase);
const results = ref(props.results);
const rawTabs = ref(props.tabs);
const currentSuggestion = ref(props.suggestion);
const currentTemasRelacionados = ref(props.temasRelacionados);
const currentPage = ref(1);
const tabs = computed(() =>
  rawTabs.value.filter((t) => t.segment === "todos" || t.count > 0),
);

const resolveMockMaisPesquisados = async () => {
  if (props.maisPesquisados?.items?.length) {
    return props.maisPesquisados;
  }

  if (typeof window !== "undefined" && window.__maisPesquisados) {
    return window.__maisPesquisados;
  }

  if (isDev) {
    const { mockMaisPesquisados } = await import("./mocks/pesquisaMocks.js");
    return {
      title: "Mais pesquisados",
      items: mockMaisPesquisados,
    };
  }

  return { title: "", items: [] };
};

const maisPesquisados = ref({ title: "", items: [] });

const loading = ref(false);

const hasSidebar = computed(
  () =>
    Array.isArray(props.maisPesquisados?.items) &&
    props.maisPesquisados.items.length > 0,
);

const filteredResults = computed(() => {
  let list = results.value;
  if (activeSegment.value !== "todos") {
    list = list.filter((r) => r.segment === activeSegment.value);
  }
  return list;
});

const totalPages = computed(() =>
  Math.max(1, Math.ceil(filteredResults.value.length / PAGE_SIZE)),
);

const paginatedResults = computed(() => {
  const start = (currentPage.value - 1) * PAGE_SIZE;
  return filteredResults.value.slice(start, start + PAGE_SIZE);
});

const totalCount = computed(() => filteredResults.value.length);
const isEmpty = computed(
  () => !loading.value && filteredResults.value.length === 0,
);

const windowWidth = ref(
  typeof window !== "undefined" ? window.innerWidth : 1024,
);
function onResize() {
  windowWidth.value = window.innerWidth;
}

const loadPesquisaMocks = async () => {
  if (!isDev) return;

  const { mockTabs, mockResults } = await import("./mocks/pesquisaMocks.js");

  const map = [
    [rawTabs, mockTabs],
    [results, mockResults],
  ];

  for (const [ref, value] of map) {
    if (!ref.value) ref.value = value;
  }
};

onMounted(async () => {
  loadPesquisaMocks();
  maisPesquisados.value = await resolveMockMaisPesquisados();
  document.body.style.background = "#F0F1F2";
  window.addEventListener("resize", onResize);

  const initialPhrase = props.phrase?.trim() ?? "";
  const needsSpellcheck =
    initialPhrase.length >= 3 && !props.suggestion && !props.results?.length;

  if (needsSpellcheck) {
    await runSearch(initialPhrase, { updateUrl: false });
  }
});
onUnmounted(() => {
  document.body.style.background = "";
  window.removeEventListener("resize", onResize);
});
const paginacaoMaxVisible = computed(() => (windowWidth.value < 768 ? 5 : 7));

watch(activeSegment, () => {
  currentPage.value = 1;
});

let searchTimer = null;
let searchRequestId = 0;

function ensureValidSegment() {
  if (!tabs.value.some((t) => t.segment === activeSegment.value)) {
    activeSegment.value = "todos";
  }
}

watch(searchQuery, (newVal) => {
  clearTimeout(searchTimer);
  const q = newVal.trim();

  if (q.length === 0) {
    results.value = props.results;
    rawTabs.value = props.tabs;
    currentSuggestion.value = props.suggestion;
    currentTemasRelacionados.value = props.temasRelacionados;

    ensureValidSegment();
    currentPage.value = 1;
    const base = props.phrase
      ? `/pesquisa?phrase=${encodeURIComponent(props.phrase)}`
      : "/pesquisa";
    history.replaceState(null, "", base);
    return;
  }

  if (q.length < 3) return;

  searchTimer = setTimeout(() => runSearch(q, { updateUrl: true }), 300);
});

async function runSearch(q, { updateUrl = true } = {}) {
  const requestId = ++searchRequestId;
  loading.value = true;
  try {
    const formData = new FormData();
    formData.append("phrase", q);
    const res = await fetch("/api/Sitecore/Indexing/SearchResultsJson", {
      method: "POST",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    });

    const data = await res.json();
    // Ignora respostas fora de ordem: só o pedido mais recente escreve estado.
    if (requestId !== searchRequestId) return;
    results.value = data.results ?? [];
    rawTabs.value = data.tabs ?? [];
    currentSuggestion.value = data.suggestion ?? null;
    currentTemasRelacionados.value = data.temasRelacionados ?? [];

    ensureValidSegment();
    currentPage.value = 1;
    if (updateUrl) {
      history.replaceState(
        null,
        "",
        `/pesquisa?phrase=${encodeURIComponent(q)}`,
      );
    }
  } catch (_) {
  } finally {
    if (requestId === searchRequestId) loading.value = false;
  }
}

function goToPage(page) {
  currentPage.value = page;
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function submitSearch() {
  if (!searchQuery.value.trim()) return;
  window.location.href = `/pesquisa?phrase=${encodeURIComponent(searchQuery.value)}`;
}

function clearSearch() {
  searchQuery.value = "";
}
</script>

<style scoped lang="scss">
.ca-pesquisa-grid {
  background: linear-gradient(
    to bottom,
    #f0f1f2 calc(100% - var(--size-8) - var(--size-6)),
    var(--ca-color-text-body) calc(100% - var(--size-8) - var(--size-6))
  );
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: clip;
  position: relative;

  &__hero {
    background: #f0f1f2;
  }

  &__title {
    color: var(--ca-color-text-body);
    margin: 0 0 var(--size-2) 0;

    @include ca-bp("sm") {
      font-size: var(--font-size-6xl);
      line-height: var(--line-height-7xl);
      letter-spacing: var(--letter-spacing-xl);
    }
  }

  &__count {
    color: var(--ca-color-text-body-variant);
    margin: 0;

    strong {
      font-weight: var(--font-weight-semibold);
      color: var(--ca-color-text-body);
    }
  }

  &__bar {
    max-width: 844px;
  }

  &__main {
    flex: 1;
    background: var(--ca-color-text-inverted);
    border-radius: var(--size-6);

    @include ca-bp("lg") {
      border-radius: var(--size-8);
    }
  }

  @media (max-width: 1023.98px) {
    &__main {
      margin-bottom: 0;
    }
  }

  &__main-content {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: var(--size-5);
    grid-template-areas:
      "filtros"
      "lista"
      "paginacao"
      "sidebar";

    @include ca-bp("md") {
      grid-template-areas:
        "filtros   filtros"
        "lista     sidebar"
        "paginacao paginacao";
      grid-template-columns: calc(8 / 12 * 100%) calc(3 / 12 * 100%);
      justify-content: space-between;
      row-gap: var(--size-11);
    }

    &--no-sidebar {
      grid-template-areas:
        "filtros"
        "lista"
        "paginacao";

      @include ca-bp("md") {
        grid-template-columns: 1fr;
        justify-content: initial;
      }
    }
  }

  &__filtros {
    grid-area: filtros;
    min-width: 0;
  }
  &__lista {
    grid-area: lista;
    min-width: 0;
  }

  &__sidebar {
    grid-area: sidebar;
    min-width: 0;
    order: 4;

    @include ca-bp("md") {
      order: unset;
    }
  }

  &__paginacao {
    grid-area: paginacao;
    display: flex;
    justify-content: center;
    min-width: 0;
    order: 3;

    @include ca-bp("md") {
      order: unset;
    }
  }
}
</style>
